import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SettingsModal from '../../../components/Game2048/ethSettingsModal';
import HamburgerButton from '../../../components/HamburgerButton';
import '../assets/2048.css';

export default function Tournament() {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [battleRankData, setBattleRankData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Mock battle rank data
    const mockBattleRankData = [
        {
            rank: 1,
            address: '0xc8Bd59d60961bEdb12c95079250d3075b9328a2d',
            name: 'Champion',
            score: 50000,
            wins: 45,
            losses: 5,
            winRate: 90.0,
            usdcPrize: 1000
        },
        {
            rank: 2,
            address: '0xabcdef1234567890abcdef1234567890abcdef12d',
            name: 'Warrior',
            score: 48000,
            wins: 42,
            losses: 8,
            winRate: 84.0,
            usdcPrize: 750
        },
        {
            rank: 3,
            address: '0x7890abcdef1234567890abcdef1234567890abcd',
            name: 'Fighter',
            score: 46000,
            wins: 40,
            losses: 10,
            winRate: 80.0,
            usdcPrize: 500
        },
        {
            rank: 4,
            address: '0x4567890abcdef1234567890abcdef1234567890ab',
            name: 'Gladiator',
            score: 44000,
            wins: 38,
            losses: 12,
            winRate: 76.0,
            usdcPrize: 300
        },
        {
            rank: 5,
            address: '0xdef1234567890abcdef1234567890abcdef123456',
            name: 'Knight',
            score: 42000,
            wins: 35,
            losses: 15,
            winRate: 70.0,
            usdcPrize: 200
        },
        {
            rank: 6,
            address: '0x234567890abcdef1234567890abcdef1234567890',
            name: 'Soldier',
            score: 40000,
            wins: 32,
            losses: 18,
            winRate: 64.0,
            usdcPrize: 150
        },
        {
            rank: 7,
            address: '0xbcdef1234567890abcdef1234567890abcdef1234',
            name: 'Guardian',
            score: 38000,
            wins: 30,
            losses: 20,
            winRate: 60.0,
            usdcPrize: 100
        },
        {
            rank: 8,
            address: '0x567890abcdef1234567890abcdef1234567890def',
            name: 'Defender',
            score: 36000,
            wins: 28,
            losses: 22,
            winRate: 56.0,
            usdcPrize: 75
        },
        {
            rank: 9,
            address: '0xef1234567890abcdef1234567890abcdef12345678',
            name: 'Protector',
            score: 34000,
            wins: 25,
            losses: 25,
            winRate: 50.0,
            usdcPrize: 50
        },
        {
            rank: 10,
            address: '0x1234567890abcdef1234567890abcdef1234567890',
            name: 'Rookie',
            score: 32000,
            wins: 22,
            losses: 28,
            winRate: 44.0,
            usdcPrize: 25
        }
    ];

    useEffect(() => {
        // Check wallet connection
        const checkWalletConnection = async () => {
            if (typeof window.ethereum !== 'undefined') {
                try {
                    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
                    if (accounts.length > 0) {
                        const address = accounts[0];
                        setUser({ address });
                        setIsAuthenticated(true);
                    }
                } catch (error) {
                    console.error('檢查錢包連接失敗:', error);
                }
            }
        };
        
        checkWalletConnection();
        
        // Load battle rank data
        loadBattleRankData();
    }, []);

    const loadBattleRankData = async () => {
        setIsLoading(true);
        try {
            // TODO: Replace with actual API call
            // const data = await fetchBattleRankData();
            // setBattleRankData(data);
            
            // Using mock data for now
            setTimeout(() => {
                setBattleRankData(mockBattleRankData);
                setIsLoading(false);
            }, 500);
        } catch (error) {
            console.error('Failed to load battle rank data:', error);
            setBattleRankData(mockBattleRankData);
            setIsLoading(false);
        }
    };

    const handleLoginSuccess = (result) => {
        console.log('Login success:', result);
        setUser({ address: result.userAddress });
        setIsAuthenticated(true);
    };

    const handleLoginError = (error) => {
        console.error('Login error:', error);
    };

    const handleLogout = () => {
        setUser(null);
        setIsAuthenticated(false);
    };

    const handleEarn = () => {
        // TODO: Implement earn functionality
        console.log('Earn button clicked');
        alert('Earn functionality will be implemented soon!');
    };

    const formatAddress = (address) => {
        if (!address) return '';
        return `${address.slice(0, 6)}...${address.slice(-4)}`;
    };

    const getRankIcon = (rank) => {
        if (rank === 1) return '🥇';
        if (rank === 2) return '🥈';
        if (rank === 3) return '🥉';
        return `#${rank}`;
    };

    const getRankColor = (rank) => {
        if (rank === 1) return '#FFD700';
        if (rank === 2) return '#C0C0C0';
        if (rank === 3) return '#CD7F32';
        return '#776e65';
    };

    // 獲取當前用戶的排名和分數
    const getUserRankInfo = () => {
        // 如果有連接錢包，嘗試從排名數據中查找
        if (user && user.address && battleRankData.length > 0) {
            const userRank = battleRankData.find(player => 
                player.address.toLowerCase() === user.address.toLowerCase()
            );
            if (userRank) {
                return userRank;
            }
        }
        
        // 默認顯示：返回零值
        return {
            rank: 0,
            score: 0,
            wins: 0,
            losses: 0,
            winRate: 0,
            usdcPrize: 0
        };
    };

    const userRankInfo = getUserRankInfo();

    return (
        <>
            <div className="game-wrapper">
                {/* Header */}
                <div className="game-header" style={{ padding: '10px 20px', minHeight: 'auto' }}>
                    <h1 className="game-title" style={{ fontSize: '1.5em', margin: '0' }}>🏆 USDC Tournament</h1>
                    <div className="scores-container">
                        <div className="info-item">
                            <span className="info-label" style={{ fontSize: '0.75em' }}>PRIZE POOL</span>
                            <span className="info-value" style={{ fontSize: '1em' }}>3,150 USDC</span>
                        </div>
                        {userRankInfo && (
                            <>
                                <div className="info-item">
                                    <span className="info-label" style={{ fontSize: '0.75em' }}>MY RANK</span>
                                    <span 
                                        className="info-value" 
                                        style={{ 
                                            fontSize: '1em',
                                            color: userRankInfo.rank > 0 ? getRankColor(userRankInfo.rank) : '#776e65'
                                        }}
                                    >
                                        {userRankInfo.rank > 0 ? getRankIcon(userRankInfo.rank) : ''} {userRankInfo.rank > 0 ? userRankInfo.rank : '0'}
                                    </span>
                                </div>
                                <div className="info-item">
                                    <span className="info-label" style={{ fontSize: '0.75em' }}>MY SCORE</span>
                                    <span className="info-value" style={{ fontSize: '1em' }}>
                                        {userRankInfo.score.toLocaleString()}
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* Hamburger Menu */}
                <div className="menu-section">
                    <HamburgerButton 
                        isOpen={isMenuOpen}
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    />
                </div>

                {/* Settings Modal */}
                <SettingsModal
                    isOpen={isMenuOpen}
                    onClose={() => setIsMenuOpen(false)}
                    user={user}
                    onLoginSuccess={handleLoginSuccess}
                    onLoginError={handleLoginError}
                    onLogout={handleLogout}
                    showBackButton={true}
                    backButtonText="← Back to Home"
                    onBackClick={() => navigate('/2048eth')}
                />

                {/* Tournament Content */}
                <div className="tournament-container">
                    {isLoading ? (
                        <div className="loading-container">
                            <div className="loading-spinner-large"></div>
                            <p>Loading rankings...</p>
                        </div>
                    ) : (
                        <>
                            {/* Battle Rank Table - Compact Design */}
                            <div className="battle-rank-table">
                                <div className="rank-table-header">
                                    <div className="rank-col">Rank</div>
                                    <div className="player-col">Player</div>
                                    <div className="score-col">Score</div>
                                    <div className="record-col">W-L</div>
                                    <div className="prize-col">Prize</div>
                                </div>
                                
                                <div className="rank-table-body">
                                    {battleRankData.map((player) => (
                                        <div 
                                            key={player.rank} 
                                            className="rank-table-row"
                                            style={{
                                                borderLeft: `3px solid ${getRankColor(player.rank)}`
                                            }}
                                        >
                                            <div className="rank-col">
                                                <span className="rank-number" style={{ color: getRankColor(player.rank) }}>
                                                    {getRankIcon(player.rank)}
                                                </span>
                                            </div>
                                            <div className="player-col">
                                                <div className="player-name">{player.name}</div>
                                                <div className="player-address">{formatAddress(player.address)}</div>
                                            </div>
                                            <div className="score-col">
                                                <span className="score-value">{player.score.toLocaleString()}</span>
                                            </div>
                                            <div className="record-col">
                                                <span className="wins">{player.wins}W</span>
                                                <span className="losses">{player.losses}L</span>
                                            </div>
                                            <div className="prize-col">
                                                <span className="prize-amount">${player.usdcPrize}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Earn Button */}
                            <div className="earn-button-container">
                                <div className="earn-warning-text">
                                    Pay 1 USDC to Win First Prize
                                </div>
                                <button 
                                    className="earn-button"
                                    onClick={handleEarn}
                                >
                                    💰 Earn USDC
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Styles */}
            <style>{`
                .tournament-container {
                    max-width: 1400px;
                    margin: 0 auto;
                    padding: 8px 20px 10px;
                    color: #776e65;
                    height: calc(100vh - 140px);
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                }

                .loading-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 40px 20px;
                }

                .loading-spinner-large {
                    width: 40px;
                    height: 40px;
                    border: 3px solid #eee4da;
                    border-top: 3px solid #8f7a66;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin-bottom: 15px;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .battle-rank-table {
                    background: #faf8ef;
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    margin-bottom: 15px;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    min-height: 0;
                }

                .rank-table-header {
                    display: grid;
                    grid-template-columns: 80px 2fr 100px 80px 90px;
                    gap: 10px;
                    padding: 8px 15px;
                    background: #eee4da;
                    font-weight: 600;
                    color: #776e65;
                    border-bottom: 2px solid #8f7a66;
                    font-size: 0.85em;
                    flex-shrink: 0;
                }

                .rank-table-body {
                    flex: 1;
                    overflow-y: auto;
                    min-height: 0;
                    /* 隱藏滾動條但保持滾動功能 */
                    -ms-overflow-style: none;  /* IE and Edge */
                    scrollbar-width: none;  /* Firefox */
                }

                /* 隱藏滾動條 - Webkit browsers (Chrome, Safari, Edge) */
                .rank-table-body::-webkit-scrollbar {
                    display: none;
                }

                .rank-table-row {
                    display: grid;
                    grid-template-columns: 80px 2fr 100px 80px 90px;
                    gap: 10px;
                    padding: 6px 15px;
                    border-bottom: 1px solid #eee4da;
                    transition: background 0.2s ease;
                    align-items: center;
                    font-size: 0.9em;
                }

                .rank-table-row:hover {
                    background: #f4f1e8;
                }

                .rank-table-row:last-child {
                    border-bottom: none;
                }

                .rank-col {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .rank-number {
                    font-size: 1em;
                    font-weight: 700;
                }

                .player-col {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                }

                .player-name {
                    font-weight: 600;
                    color: #776e65;
                    font-size: 0.95em;
                }

                .player-address {
                    font-size: 0.75em;
                    font-family: monospace;
                    opacity: 0.7;
                    color: #776e65;
                }

                .score-col, .record-col, .prize-col {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .score-value {
                    font-weight: 600;
                    color: #776e65;
                    font-size: 0.9em;
                }

                .wins {
                    color: #4caf50;
                    font-weight: 600;
                    margin-right: 5px;
                    font-size: 0.85em;
                }

                .losses {
                    color: #f44336;
                    font-weight: 600;
                    font-size: 0.85em;
                }

                .prize-amount {
                    font-weight: 700;
                    color: #FFD700;
                    font-size: 0.95em;
                }

                .earn-button-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 8px 0;
                    flex-shrink: 0;
                    gap: 8px;
                }

                .earn-warning-text {
                    font-size: 0.9em;
                    color: #8f7a66;
                    font-weight: 600;
                    text-align: center;
                    padding: 6px 12px;
                    background: rgba(255, 215, 0, 0.1);
                    border-radius: 6px;
                    border: 1px solid rgba(255, 215, 0, 0.3);
                }

                .earn-button {
                    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
                    color: #333;
                    border: none;
                    border-radius: 10px;
                    padding: 12px 40px;
                    font-size: 1.05em;
                    font-weight: 700;
                    cursor: pointer;
                    box-shadow: 0 4px 15px rgba(255, 215, 0, 0.4);
                    transition: all 0.3s ease;
                    min-width: 220px;
                }

                .earn-button:hover {
                    background: linear-gradient(135deg, #FFA500 0%, #FF8C00 100%);
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(255, 215, 0, 0.6);
                }

                .earn-button:active {
                    transform: translateY(0);
                }

                /* Responsive Design */
                @media (max-width: 1024px) {
                    .tournament-container {
                        padding: 6px 15px 8px;
                        height: calc(100vh - 130px);
                    }

                    .rank-table-header,
                    .rank-table-row {
                        grid-template-columns: 70px 1.8fr 90px 70px 80px;
                        gap: 8px;
                        padding: 8px 12px;
                        font-size: 0.85em;
                    }
                }

                @media (max-width: 768px) {
                    .tournament-container {
                        padding: 5px 10px 8px;
                        height: calc(100vh - 120px);
                    }

                    .rank-table-header,
                    .rank-table-row {
                        grid-template-columns: 60px 1.5fr 70px 60px 70px;
                        gap: 6px;
                        padding: 6px 10px;
                        font-size: 0.8em;
                    }

                    .player-address {
                        font-size: 0.7em;
                    }

                    .earn-button {
                        padding: 12px 32px;
                        font-size: 1em;
                        min-width: 180px;
                    }

                    .earn-warning-text {
                        font-size: 0.85em;
                        padding: 5px 10px;
                    }

                    /* 手機版設置按鈕變小 */
                    .menu-section {
                        transform: scale(0.85);
                        transform-origin: top right;
                    }
                }

                @media (max-width: 480px) {
                    .tournament-container {
                        padding: 5px 10px 5px;
                        height: calc(100vh - 120px);
                    }

                    .battle-rank-table {
                        max-height: calc(100vh - 280px);
                        margin-bottom: 10px;
                    }

                    .rank-table-header,
                    .rank-table-row {
                        grid-template-columns: 100px 1.2fr 50px 50px;
                        gap: 5px;
                        padding: 5px 8px;
                    }

                    .rank-table-header {
                        padding: 6px 8px;
                    }

                    .record-col {
                        display: none;
                    }

                    .prize-col {
                        font-size: 0.85em;
                    }

                    .earn-button-container {
                        padding: 5px 0;
                    }

                    .earn-button {
                        padding: 12px 32px;
                        font-size: 1em;
                        min-width: 180px;
                    }

                    .earn-warning-text {
                        font-size: 0.8em;
                        padding: 4px 8px;
                    }

                    /* 手機版設置按鈕變小 */
                    .menu-section {
                        transform: scale(0.8);
                        transform-origin: top right;
                    }
                }
            `}</style>
        </>
    );
}

